import { Bundle, Tier } from '../models/pricing.model';
import { FormGroup, ValidatorFn } from '@angular/forms';
import { Validators as V } from './validation.service';

export function suggestFlashCallPrice(model: Bundle | Tier, products: (Bundle | Tier)[], form: FormGroup, effectiveDate?: string): void {
  // Reopened products (saved or still in the list) keep the price the manager set.
  if (model.serviceType !== 'FLASH_CALL' || model.id || 'index' in model) return;
  const date = model.visibleFrom || effectiveDate || new Date().toISOString().slice(0, 10);
  const candidates = products.filter(
    product =>
      !product.hidden &&
      (!product.visibleFrom || product.visibleFrom <= date) &&
      (!product.visibleUntil || new Date(product.visibleUntil) > new Date(date))
  );
  const rate = (service: string) =>
    candidates
      .filter(product => product.serviceType === service || (service === 'CLI' && product.serviceType === 'VOICE'))
      .sort((a, b) => (b.visibleFrom || '').localeCompare(a.visibleFrom || ''))[0]?.ratePerUnit;
  const lnt = rate('MT');
  const cli = rate('CLI');
  if (lnt == null || cli == null) return;
  model.ratePerUnit = Math.round((Number(lnt) + Number(cli)) * 1000) / 1000;
  form.controls.ratePerUnit.setValue(model.ratePerUnit);
}

export function configureFlashCallTier(model: Tier, products: Tier[], form: FormGroup): void {
  if (model.serviceType === 'FLASH_CALL') {
    model.commitment = null;
    form.controls.commitment.setValue(null);
  } else {
    form.controls.commitment.updateValueAndValidity();
  }
  suggestFlashCallPrice(model, products, form);
}

export function flashCallTierCommitmentValidator(model: () => Tier): ValidatorFn {
  const requiredCommitment = V.compose([V.required, V.digitsAndDot(true), V.min(0.001, false), V.price(3, true)]);
  return control => (model()?.serviceType === 'FLASH_CALL' ? null : requiredCommitment(control));
}
